// ! PubSub being a global messaging system, please use "WORKFLOW/" before the keys.

export enum WorkflowPubSubActions {
  /**
   * Reload for Logs or Files
   * payload: activity node id in case of activity web socket message, null for workflow
   */
  RELOAD_OUTPUT = "WORKFLOW/RELOAD_OUTPUT",
}
